import Analytics from '@components/charts/analytics/Analytics'
import AppMostViewedScreen from '@components/charts/user/AppMostViewedScreen'
import AverageSessionDuration from '@components/charts/user/AverageSessionDuration'
import AverageSessionDurationPerUser from '@components/charts/user/AverageSessionDurationPerUser'
import DailyActiveUser from '@components/charts/user/DailyActiveUser'
import GlobalVenuesOpening from '@components/charts/venue/GlobalVenuesOpening'
import Page from '@components/Page/Page'
import { AnalyticsProvider } from '@contexts/AnalyticsContext'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Permission } from '@utils/permissions'
import { Col, Typography } from 'antd'
import dayjs, { Dayjs } from 'dayjs'

const { Text } = Typography

const TrafficPage = () => {
  return (
    <AnalyticsProvider>
      <Page permissions={Permission.viewOverview} noWrapWithCol>
        <Col span={24}>
          <PageTitle
            title="Mobile application insights"
            level={4}
            toolbar={
              <Analytics.Date
                minDate={dayjs('2025-11-20')}
                rangePresets={Analytics.rangesPresets.venue}
                defaultValue={
                  Analytics.rangesPresets.venue![0].value as [Dayjs, Dayjs]
                }
              />
            }
          />
        </Col>
        <Col span={12}>
          <DailyActiveUser />
        </Col>
        <Col span={12}>
          <AverageSessionDurationPerUser />
        </Col>
        <Col span={24}>
          <GlobalVenuesOpening />
        </Col>
        <Col span={12}>
          <AppMostViewedScreen />
        </Col>
        <Col span={12}>
          <AverageSessionDuration />
        </Col>
      </Page>
    </AnalyticsProvider>
  )
}

export default TrafficPage
